// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"d4139fd1","129":"d4139fd1","451":"5286a770","570":"5286a770","640":"5286a770"}[chunkId] + ".chunk.css";
};